import React, { useRef, useEffect } from "react";
import { Icon } from "../../ui";
import { ROLES } from "../../lib/roles";

export function AnnouncementCard({
  a,
  lang,
  canShowReadCount,
  canEditAnn,
  deleteConfirmId,
  setDeleteConfirmId,
  onEdit,
  onDelete,
  onRead,
  setLightbox,
}) {
  const cardRef = useRef(null);
  const readSentRef = useRef(false);

  useEffect(() => {
    const el = cardRef.current;
    if (!el || readSentRef.current || a.readByMe) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting) && !readSentRef.current) {
          readSentRef.current = true;
          onRead(a.id);
        }
      },
      { threshold: 0.35 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [a.id, a.readByMe, onRead]);

  return (
    <div ref={cardRef} className={`ann-card ${a.pinned ? "ann-card-pinned" : ""}`}>
      <div className="ann-meta">
        {a.pinned && <span className="ann-tag ann-tag-pin">📌 {lang === "gr" ? "Καρφιτσωμένο" : "Pinned"}</span>}
        <span className={`ann-tag ${a.store === "All Stores" ? "ann-tag-all" : "ann-tag-store"}`}>
          {a.store === "All Stores" ? (lang === "gr" ? "Παντού" : "All Stores") : a.store}
        </span>
        <span className="ann-date">{a.editedAt ? `${a.date} (${lang === "gr" ? "επεξ." : "edited"} ${a.editedAt})` : a.date}</span>
        {canEditAnn && (
          <div className="ann-actions">
            <button className="ann-action-btn ann-action-edit" title="Edit" onClick={() => onEdit(a)}>
              <Icon name="pencil" size={13} />
            </button>
            <button className="ann-action-btn ann-action-delete" title="Delete" onClick={() => setDeleteConfirmId(deleteConfirmId === a.id ? null : a.id)}>
              <Icon name="close" size={13} />
            </button>
          </div>
        )}
      </div>

      {deleteConfirmId === a.id && (
        <div className="ann-delete-confirm">
          <div style={{ fontSize: 13, fontWeight: 700, color: "var(--danger)", marginBottom: 10 }}>
            {lang === "gr" ? "Διαγραφή αυτής της ανακοίνωσης;" : "Delete this announcement?"}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn-base btn-danger-soft btn-small" style={{ flex: 1, justifyContent: "center" }} onClick={() => onDelete(a.id)}>
              {lang === "gr" ? "Ναι, διαγραφή" : "Yes, delete"}
            </button>
            <button className="btn-base btn-outline btn-small" onClick={() => setDeleteConfirmId(null)}>
              {lang === "gr" ? "Ακύρωση" : "Cancel"}
            </button>
          </div>
        </div>
      )}

      <div className="ann-title">{a.title}</div>
      <div className="ann-body">{a.body}</div>

      {a.photo && (
        <div className="ann-photo" onClick={() => setLightbox(a.photo)} style={{ marginTop: 12 }}>
          <img src={a.photo} alt={a.title} />
          <span style={{ position: "absolute", bottom: 8, right: 10, background: "rgba(0,0,0,0.5)", color: "#fff", fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 20 }}>
            🔍 {lang === "gr" ? "Μεγέθυνση" : "View"}
          </span>
        </div>
      )}

      <div className="ann-author">
        <Icon name="user" size={11} />
        {a.author} · <span style={{ color: ROLES[a.role]?.color, fontWeight: 700 }}>{ROLES[a.role]?.label}</span>
        {canShowReadCount && (
          <span style={{ marginLeft: "auto", fontSize: 11, color: "var(--text-muted)" }}>
            {a.readCount} {lang === "gr" ? "ανάγνωση" : "read"}{a.readCount === 1 ? "" : "s"}
          </span>
        )}
      </div>
    </div>
  );
}

